<h2 mat-dialog-title>🎯 Create Custom Filter</h2>

<mat-dialog-content class="dialog-content">
  <div class="filter-form">
    <!-- Nom du filtre -->
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Filter Name</mat-label>
      <input matInput 
             [(ngModel)]="currentFilter.name"
             name="name"
             placeholder="Enter a descriptive name for your filter"
             maxlength="50">
      <mat-hint>Choose a name that describes what this filter does</mat-hint>
    </mat-form-field>

    <!-- Preview du filtre (au-dessus des onglets) -->
    <div class="filter-preview-above" *ngIf="getFilterPreviewText()">
      <p class="preview-text">
        <mat-icon [inline]="true" class="preview-icon">filter_list</mat-icon>
        {{ getFilterPreviewText() }}
      </p>
      <button mat-raised-button 
              color="primary" 
              (click)="pasteFromClipboard()"
              class="paste-button">
        <mat-icon>content_paste</mat-icon>
        Paste from Clipboard
      </button>
    </div>

    <!-- Visual Builder (sans onglets) -->
    <mat-card class="builder-card">
      <mat-card-header>
        <mat-card-title>Build Your Filter</mat-card-title>
        <mat-card-subtitle>Create conditions visually</mat-card-subtitle>
      </mat-card-header>
      <mat-card-content>
        <!-- Bouton pour ajouter un critère -->
        <div class="add-criteria-section">
          <button mat-raised-button 
                  color="primary" 
                  (click)="addCondition()"
                  class="add-criteria-btn">
            <mat-icon>add</mat-icon>
            Add Criteria
          </button>
        </div>

        <!-- Liste des critères -->
        <div class="criteria-list" *ngIf="getConditions().length > 0">
          <div class="criteria-item" 
               *ngFor="let condition of getConditions(); let i = index">
            
            <!-- Champ -->
            <mat-form-field appearance="outline" class="criteria-field">
              <mat-label>Field</mat-label>
              <mat-select [(ngModel)]="condition.field" name="field">
                <mat-option *ngFor="let field of availableFields" [value]="field.value">
                  {{ field.label }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <!-- Opérateur -->
            <mat-form-field appearance="outline" class="criteria-operator">
              <mat-label>Operator</mat-label>
              <mat-select [(ngModel)]="condition.operator" name="operator">
                <mat-option *ngFor="let op of operators" [value]="op.value">
                  {{ op.label }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <!-- Valeur -->
            <mat-form-field appearance="outline" class="criteria-value" 
                           *ngIf="!isNullOperator(condition.operator)">
              <mat-label>Value</mat-label>
              
              <input matInput
                     *ngIf="getInputType(condition.field, condition.operator) === 'text'"
                     [(ngModel)]="condition.value"
                     name="value"
                     [placeholder]="getValuePlaceholder(condition.field, condition.operator)">
              
              <input matInput
                     *ngIf="getInputType(condition.field, condition.operator) === 'datetime-local'"
                     type="datetime-local"
                     [(ngModel)]="condition.value"
                     name="value"
                     [placeholder]="getValuePlaceholder(condition.field, condition.operator)">

              <mat-select *ngIf="getInputType(condition.field, condition.operator) === 'select'"
                     [(ngModel)]="condition.value"
                     name="value">
                     <!--mat-option *ngFor="let option of getFieldOptions(condition.field)" [value]="option.value">
                       {{ option.label }}
                     </mat-option-->
              </mat-select>
            </mat-form-field>

            <!-- Bouton supprimer -->
            <button mat-icon-button 
                    color="warn" 
                    (click)="removeCondition(i)"
                    class="remove-criteria-btn">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </div>

        <!-- État vide -->
        <div class="empty-state" *ngIf="getConditions().length === 0">
          <mat-icon>filter_list</mat-icon>
          <p>No criteria yet. Click "Add Criteria" to get started.</p>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">Cancel</button>
  <button mat-raised-button 
          color="primary" 
          (click)="onCreate()"
          [disabled]="!isFilterValid()">
    <mat-icon>check</mat-icon>
    Create Filter
  </button>
</mat-dialog-actions>